
const initialState = {
    hasInternet: true,
    loggedIn: false,
    newImageAdded1: 0,
    cart: [],
    allImgs: [],
    allCats: []
}

const rootReducer = (state = initialState, action ) => {
    switch(action.type) {
        case SET_INET_STATUS:
            return { ...state, hasInternet: action.payload}
        case SET_LOGGED:
            return {...state, loggedIn: action.payload}
        // case MANAGE_IMGMODAL_STATUS:
        //     return {...state}
        // case ADD_COUNT:
        //     return {...state, counter: state.counter}
        case NEW_IMAGE_ADDED:
            // console.log(action.payload);
            return {...state, newImageAdded1: action.payload }
        case ADD2CART:
            return {...state, cart: state.cart.concat(action.payload)}
        case REMOVE_FROM_CART:
            return {...state, cart: removeFromCart(state.cart, action.payload)}
        case BKUP_IMAGES:
            return {...state, allImgs: action.payload}
        case BKUP_CATS:
            return {...state, allCats: action.payload}
        default:
            return state;
    }
}

export default rootReducer;

const SET_INET_STATUS = "SET_INET_STATUS";
// const MANAGE_IMGMODAL_STATUS = "MANAGE_IMGMODAL_STATUS";
const SET_LOGGED = "SET_LOGGED";
const NEW_IMAGE_ADDED = "NEW_IMAGE_ADDED";
const ADD2CART = "ADD2CART";
const REMOVE_FROM_CART = "REMOVE_FROM_CART";
const BKUP_IMAGES = "BKUP_IMAGES";
const BKUP_CATS = "BKUP_CATS";

function removeFromCart(cart, item){
    const arr = [];
    cart.forEach(inItem => {
        if(inItem !== item){
            arr.push(inItem)
        }
    });
    return arr;
}


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js